// Thin wrapper component - handles client-side parsing with useMemo optimization
import { useMemo } from "react"
import { EquifaxPrequalReport } from "@prescreen/lib/equifax-prequal-report"
import { CreditEvaluation } from "@prescreen/lib/types/credit-evaluation"
import { EquifaxReportViewContent } from "./EquifaxReportViewContent"
import { EvaluationsSection } from "./EvaluationsSection"

interface EquifaxReportViewProps {
  rawReport: unknown
  evaluations?: CreditEvaluation[]
  reportTitle?: string
  bureau?: string
}

export function EquifaxReportView({ rawReport, evaluations, reportTitle, bureau }: EquifaxReportViewProps) {
  const report = useMemo(() => {
    try {
      const typedReport = rawReport as { consumers?: { equifaxUSConsumerCreditReport?: unknown[] } }
      const rawData = typedReport?.consumers?.equifaxUSConsumerCreditReport?.[0]
      if (rawData) {
        return new EquifaxPrequalReport(rawData as ConstructorParameters<typeof EquifaxPrequalReport>[0])
      }
      return null
    } catch (error) {
      console.error('Error parsing report:', error)
      return null
    }
  }, [rawReport])

  return (
    <EquifaxReportViewContent 
      report={report} 
      evaluations={evaluations} 
      rawReport={rawReport}
      reportTitle={reportTitle}
      bureau={bureau}
      evaluationsComponent={evaluations && evaluations.length > 0 ? (
        <EvaluationsSection evaluations={evaluations} />
      ) : undefined}
    />
  )
}

